import Vue from 'vue';
import Axios from '@/global/http.js';
import App from './index.vue';
import AuthUi from '@/global/authui.js';

// 懒加载
import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload, { // options
    preLoad: 1
});

Vue.use(AuthUi);
Vue.prototype.$axios = Axios;

new Vue({
    render: h => h(App),
}).$mount('#app');
